/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
/**
 * <pre><code>Represents different data types of fields.
 * <\/code><\/pre>
 **/
export var FieldType;
(function (FieldType) {
    FieldType["STRING"] = "STRING";
    FieldType["DATE"] = "DATE";
    FieldType["NUMBER"] = "NUMBER";
})(FieldType || (FieldType = {}));
